import { gql } from 'graphql.macro'

export default  gql`
  fragment RoleFragment on Role {
    id
    name
  }
`
